import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Siren } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useSeo, Loader, EmptyState } from "../components/kit";
import MapView from "../components/MapView";
import { UrgentJobCard } from "../components/Urgent";

export default function UrgentJobs() {
  const { user, cats } = useAuth();
  const [category, setCategory] = useState("");
  const [jobs, setJobs] = useState(null);
  const [active, setActive] = useState(null);
  useSeo("Urgent jobs", "Urgent home-service jobs from local homeowners who need a professional fast.");
  useEffect(() => { setJobs(null); api.get("/urgent-jobs", { params: { category } }).then((r) => setJobs(r.data)); }, [category]);
  const pins = (jobs || []).map((j) => ({ id: j.id, lat: j.lat, lng: j.lng, business_name: j.title }));
  const first = pins.find((p) => p.lat);
  return (
    <div>
      <section className="bg-[#FAF7EE]"><div className="container-x py-12">
        <span className="eyebrow !text-rose-600">Urgent jobs</span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Homeowners who need help fast</h1>
        <p className="text-slate-600 mt-2 max-w-2xl">{user?.role === "provider" ? "Open a job to see the details and send your quote." : "Are you a professional? Log in to see full details and quote. Need help fast yourself? Post a job and make it urgent."}</p>
        <div className="flex flex-wrap gap-3 mt-6">
          <select className="input w-64" value={category} onChange={(e) => setCategory(e.target.value)} aria-label="Category" data-testid="urgent-category"><option value="">All categories</option>{cats.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}</select>
          {user?.role !== "provider" && <Link to="/post-job" className="btn-coral" data-testid="urgent-post-job-btn">Post an urgent job</Link>}
        </div>
      </div></section>
      <div className="container-x py-8">
        {!jobs ? <Loader /> : jobs.length === 0 ? <EmptyState icon={Siren} title="No urgent jobs right now" text="Check back soon, new urgent jobs appear here the moment they're posted." testid="urgent-empty" /> : (
          <div className="grid lg:grid-cols-[1fr_minmax(0,520px)] gap-6">
            <div className="grid sm:grid-cols-2 gap-4 content-start" data-testid="urgent-jobs-list">
              <p className="sm:col-span-2 text-sm text-slate-600" data-testid="urgent-count">{jobs.length} urgent job{jobs.length === 1 ? "" : "s"}</p>
              {jobs.map((j) => <UrgentJobCard key={j.id} j={j} active={active === j.id} onHover={setActive} />)}
            </div>
            <div className="lg:sticky lg:top-24 h-[60vh] lg:h-[calc(100vh-8rem)]">
              <MapView items={pins} activeId={active} onSelect={setActive} center={first ? [first.lat, first.lng] : undefined} zoom={9} testid="urgent-map" />
            </div>
          </div>)}
      </div>
    </div>
  );
}
